export const kmFields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    sortable: true,
    isLocked: true,
  },
  {
    key: 'status',
    label: 'maintenance.field.statusService',
    header: 'serviceStatus',
    filter: true,
    sortable: true,
    isLocked: true,
  },
  {
    key: 'service',
    label: 'maintenance.frontPage.title.serviceSchedule',
    header: 'service',
    filter: false,
    isLocked: true,
  },
  {
    key: 'ssgroup',
    label: 'maintenance.frontPage.title.serviceGroup',
    header: 'serviceGroup',
    filter: false,
  },
  {
    key: 'intervalDistance',
    label: 'report.fields.intervalDistance',
    header: 'serviceIntervalDistance',
    filter: false,
  },
  {
    key: 'startServiceAtDistance',
    label: 'report.fields.startServiceAtDistance',
    header: 'startServiceAtDistance',
    filter: false,
  },
  {
    key: 'vehicle.odometer',
    label: 'report.fields.lastServiceDistance',
    header: 'serviceOdometer',
    filter: false,
  },
  {
    key: 'serviceDistanceDifference',
    label: 'maintenance.form.kilometerDifference',
    header: 'serviceDistanceDifference',
    filter: false,
  },
  {
    key: 'intervalTime',
    label: 'report.fields.intervalTime',
    header: 'serviceIntervalTime',
    filter: false,
  },
  {
    key: 'startServiceAtTime',
    label: 'report.fields.startServiceAtTime',
    header: 'startServiceAtTime',
    filter: false,
    sortable: true,
  },
  {
    key: 'serviceTimeDifference.readableText',
    label: 'maintenance.form.timeDifference',
    header: 'serviceTimeDifference',
    filter: false,
  },
]

export const hourmeterFields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    sortable: true,
    isLocked: true,
  },
  {
    key: 'status',
    label: 'maintenance.field.statusService',
    header: 'serviceStatus',
    filter: true,
    sortable: true,
    isLocked: true,
  },
  {
    key: 'service',
    label: 'maintenance.frontPage.title.serviceSchedule',
    header: 'service',
    filter: false,
    isLocked: true,
  },
  {
    key: 'ssgroup',
    label: 'maintenance.frontPage.title.serviceGroup',
    header: 'serviceGroup',
    filter: false,
  },
  {
    key: 'intervalHourmeter',
    label: 'maintenance.form.hourmeterInterval',
    header: 'intervalHourmeter',
    filter: false,
  },
  {
    key: 'startServiceAtHourmeter',
    label: 'maintenance.field.nextHourmeterService',
    header: 'startServiceAtHourmeter',
    filter: false,
  },
  {
    key: 'totalDurationHourmeter',
    label: 'maintenance.hourmeter.totalDuration',
    header: 'serviceHourmeter',
    filter: false,
  },
  {
    key: 'serviceHourmeterDifference',
    label: 'maintenance.field.serviceHourmeterDifference',
    header: 'serviceHourmeterDifference',
    filter: false,
  },
]
